export enum FarmerReprocessingScope {
  FarmerScoped = 'farmer-scoped',
  // The rewards engine processes all unprocessed OrderTransaction Rows
  // Can have queue rows to also individually partially reprocess certain farmers
  FullRetailer = 'full-retailer',
  // No queue rows: the run picks an active or future program and
  // figures out tier overrides for the farmers
  TierOverrideGeneration = 'tier-override-generation',
}
